import { cn } from '@app/shared/utils/common';

interface RadioItemProps {
  label?: string;
  icon?: string;
  isActive?: boolean;
  onClick?: () => void;
}

export function RadioItem({ label, icon, isActive = false, onClick }: RadioItemProps) {
  return (
    <div
      className={cn(
        'flex cursor-pointer items-center justify-center gap-0.5 rounded-full border border-accent px-4 py-2 text-sm font-medium',
        isActive && 'bg-blue-light text-secondary-foreground'
      )}
      onClick={onClick}
    >
      {label && <span>{label}</span>}
      {icon && <span>{icon}</span>}
    </div>
  );
}
